module.exports = "https://static.wmbcdn.com/uniweb/images/84e0e0da3dab86b44b9efac4ff852368.svg";